export const FLAT_RATE_PRICING_ITEM_TYPE = 'FLAT_RATE';
export const PER_UNIT_PRICING_ITEM_TYPE = 'PER_UNIT';
export const PVV_PRICING_NOT_SUPPORTED_MSG = 'Paid via Vendor pricing is not supported';

// Infinite unit count should be represented by Infinity